module.exports = {
    FIREBASE_CONFIG: {
        apiKey: "AIzaSyBexzgXfij8fw6kavJNeNzcBurBzyK5JDI",
        authDomain: "wolfdaohowl.firebaseapp.com",
        databaseURL: "https://wolfdaohowl.firebaseio.com",
        projectId: "wolfdaohowl",
        storageBucket: "",
        messagingSenderId: "552965163906"
    },
};
    


// WEBPACK FOOTER //
// ./src/settings/Firebase/index.js